import { ContextSetter, setContext } from 'apollo-link-context';
import { DocumentNode } from 'graphql';
import hmacSHA1 from 'crypto-js/hmac-sha1';
import Base64 from 'crypto-js/enc-base64';
import { createQueryAndMutateFunctions } from './common';
import { ENDPOINTS } from '@/settings/endpoints';

export const eponaAuth: ContextSetter = (_, { headers }) => {
  const token = localStorage.getItem('token');

  if (token) {
    return {
      headers: {
        ...headers,
        authorization: `Bearer ${token.replace(/"/g, '')}`,
      },
    };
  }

  return headers;
};

export const { query, mutate: eponaMutation } = createQueryAndMutateFunctions(
  ENDPOINTS.epona,
  setContext(eponaAuth),
);

export const eponaQuery = (queryString: DocumentNode, variables?: { [key: string]: any }) =>
  query(queryString, {
    ...variables,
    // Used to distinguish Stellate cache by user
    t: Base64.stringify(hmacSHA1(window.POCKET.profile()?.id.toString(), 'epo')),
  });
